<div class="wrapper__headerComponent container my-5">
    <div class="row align-items-center">
        <div class="col-12 col-md-3"></div>
        <div class="col-12 col-md-6">
            <h2 class="text-center h3-tipografia-govco mb-0">
                {{"gestion-evento-entidad.titulo" | translate}} {{getNombreEntidad(idEntidad)}}
            </h2>
        </div>
    </div>
</div>
<div class="wrapper__contentComponent--expediente container my-5">
    <div class="d-flex flex-wrap justify-content-end gap-2 mb-5">
        <button id="btn-agregarEventoEntidad"
                class="btn-govco outline-btn-govco hvr-shrink"
                (click)="modalVer()"
                aria-label="Agregar evento">
            {{"gestion-evento-entidad.btn-agregar" | translate}}
        </button>
        <!-- Botón Editar: solo habilitado si hay exactamente 1 seleccionado -->
        <button id="btn-editarEventoEntidad"
                class="btn-govco outline-btn-govco hvr-shrink"
                [disabled]="cantidadSeleccionados !== 1"
                (click)="editarEvento()"
                aria-label="Editar evento">
            {{"gestion-evento-entidad.btn-editar" | translate}}
        </button>

        <!-- Botón Eliminar: habilitado si hay 1 o más seleccionados -->
        <button id="btn-eliminarEventoEntidad"
                class="btn-govco outline-btn-govco hvr-shrink"
                [disabled]="cantidadSeleccionados === 0"
                (click)="abrirModalBorrar()"
                aria-label="Eliminar evento(s)">
            {{"gestion-evento-entidad.btn-eliminar" | translate}}
        </button>
    </div>
    <div class="w-100">
        <div class="container my-4">
            <div class="row g-3">
            <div class="col-12 col-md-6 col-lg-4" 
                *ngFor="let evento of eventosMostrados; let i = index">
                <div class="card h-100">
                <div class="row g-0">
                    <div class="col-12 d-flex justify-content-center align-items-center p-2">
                        <img [src]="evento.Imagen"
                            [alt]="evento.Nombre_Evento"
                            class="event-img">
                    </div>
                    <div class="col">
                    <div class="card-body">
                        <h5 class="card-title mb-1" *ngIf="evento.Nombre_Evento">{{ evento.Nombre_Evento }}</h5>
                        <p class="card-text mb-2">{{ evento.Descripcion_Evento }}</p>
                        <p class="card-text mb-1">{{ evento.Fecha | date }} - {{ getFormatHora(evento.Hora)}}</p>
                        <div class="card-text mb-2">
                        <div *ngIf="isLink(evento); else noLink">
                            <a [href]="evento.Lugar" target="_blank" class="link-primary">
                            {{"gestion-evento-entidad.link-inscripcion" | translate}}
                            </a>
                        </div>
                        <ng-template #noLink>
                            {{ evento.Lugar }}
                        </ng-template>
                        </div>
                        <div class="form-check">
                        <input class="form-check-input"
                                type="checkbox"
                                [id]="'seleccionarEvento' + i"
                                (change)="toggleSeleccion(evento, $event)">
                        <label class="form-check-label" [for]="'seleccionarEvento' + i">
                            {{"gestion-evento-entidad.seleccione-evento" | translate}}
                        </label>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div> 
            </div>
        </div>

        <!-- Botón Ver más / Ver menos -->
        <div class="d-flex justify-content-center" *ngIf="eventos.length > cantidadEventos">
            <button class="btn-govco fill-btn-govco hvr-shrink" (click)="verMas()"
                aria-label="Ver más o ver menos eventos">
            {{ eventosVisibleCount < eventos.length 
                ? ('gestion-evento-entidad.btn-ver-mas' | translate) 
                : ('gestion-evento-entidad.btn-ver-menos' | translate) }}
            </button>
        </div>
    </div>
</div>
<app-modal-gestion-eventos-entidad (cargarListas)="cargarListas($event)" [eventosEliminar]="eventosSeleccionados"></app-modal-gestion-eventos-entidad>